export default __webpack_public_path__ + "static/pattern-green-5adee5f2921c6308164521d257c853c5.jpg";